import { serviceWorkerRegistration } from "../serviceWorkerRegistration";

export function startup_registerServiceWorker() {
  serviceWorkerRegistration.register();
}
